const MONTHS = [
  0,
  'enero',
  'febrero',
  'marzo',
  'abril',
  'mayo',
  'junio',
  'julio',
  'agosto',
  'septiembre',
  'octubre',
  'noviembre',
  'diciembre',
]
function parseDateStr(dateStr) {
  // expected:'2023-02-01'
  let splitDate = dateStr.split('-')
  let year = splitDate[0]
  let month = MONTHS[parseInt(splitDate[1])]
  let date = parseInt(splitDate[2])
  return {
    date,
    month,
    year,
  }
}
export default function formatDateStr(
  { startDate, endDate },
  format = 'Del $startDate.date de $startDate.month al $endDate.date de $endDate.month'
) {
  let date1 = parseDateStr(startDate)
  let date2 = parseDateStr(endDate)
  return format
    .replace('$startDate.date', date1.date)
    .replace('$startDate.month', date1.month)
    .replace('$startDate.year', date1.year)
    .replace('$endDate.date', date2.date)
    .replace('$endDate.month', date2.month)
    .replace('$endDate.year', date2.year)
}
